import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { P24_DISPOSITIONS_EMAIL, P24_DISPOSITIONS_PHONE } from '@repo/shared/constants';

import { TileLink } from './tile-link';

export function CompleteDataContact() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginTop: '40px',
          maxWidth: '335px',
        }}
      >
        <TileLink link={`mailto:${P24_DISPOSITIONS_EMAIL}`} icon={<EmailOutlinedIcon width={24} />}>
          <Typography component="span" fontSize={20}>
            {P24_DISPOSITIONS_EMAIL}
          </Typography>
        </TileLink>

        <TileLink link={`tel:${P24_DISPOSITIONS_PHONE}`} icon={<PhoneInTalkIcon />}>
          <Box component="span" sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography component="span" fontSize={20}>
              {P24_DISPOSITIONS_PHONE}
            </Typography>
            <Typography component="span" fontSize={12}>
              {t('welcomePage.loanApplicationPossible.liberis.completeDataContact.receptionHours')}
            </Typography>
          </Box>
        </TileLink>
      </Box>
      <Typography fontSize={13}>
        {t('welcomePage.loanApplicationPossible.liberis.completeDataContact.disclaimer')}
      </Typography>
    </Box>
  );
}
